import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";

export type healthStatusType = 'Healthy' | 'Degraded' | 'Unhealthy' | 'Error';

export interface AegisHealthCheck {
    api: healthStatusType;
    database: healthStatusType;
    frontend?: healthStatusType;

}

export const _HealthCheckEndpoints = {
    Api: (): IApiEndpoint<healthStatusType> => ({
        url: '/api/HealthChecks/Api',
        method: 'GET'
    }),
    Database: (): IApiEndpoint<healthStatusType> => ({
        url: '/api/HealthChecks/Database',
        method: 'GET'
    }),
    All: (): IApiEndpoint<AegisHealthCheck> => ({
        url: '/api/HealthChecks/All',
        method: 'GET'
    })
}